import React from 'react';
import { Bot, GitMerge, Zap, Shield } from 'lucide-react';
export const CoreOffering = () => {
  return <section id="features" className="py-20 bg-black relative overflow-hidden" data-id="element-107">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-108"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-110">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-111">
            Core <span className="text-white" data-id="element-112">Offering</span>
          </h2>
          <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-113">
            Our AI solution enhances your existing intake process across all
            major communication channels, working alongside your team to improve
            efficiency and client experience, whether your intake is managed
            in-house or by a call center.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-114">
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-115">
            <Bot size={32} className="text-white mb-6" data-id="element-116" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-117">
              Advanced AI Assistant
            </h3>
            <p className="font-['Playfair_Display'] text-zinc-300 font-light" data-id="element-118">
              Trained specifically on legal intake workflows, our AI acts as the
              first responder for new inquiries, collecting essential
              information before seamlessly handing off to your team.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-119">
            <GitMerge size={32} className="text-white mb-6" data-id="element-120" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-121">
              Seamless Integration
            </h3>
            <p className="font-['Playfair_Display'] text-zinc-300 font-light" data-id="element-122">
              Choose how our AI works with your team—either as the first point
              of contact or as backup for overflow, after-hours, weekends, and
              foreign-language conversations.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-123">
            <Shield size={32} className="text-white mb-6" data-id="element-124" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-125">
              Augment Your Team
            </h3>
            <p className="font-['Playfair_Display'] text-zinc-300 font-light" data-id="element-126">
              Our AI doesn't replace your staff—it enhances their capabilities
              by handling routine inquiries, qualifying leads, and ensuring no
              potential client goes unattended.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-127">
            <Zap size={32} className="text-white mb-6" data-id="element-128" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-129">
              Performance Analytics
            </h3>
            <p className="font-['Playfair_Display'] text-zinc-300 font-light" data-id="element-130">
              Track and analyze how the AI performs compared to your current
              process, with detailed metrics to help you optimize your client
              acquisition strategy.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-131">
          <a href="/features" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-block" data-id="element-132">
            Explore All Features
          </a>
        </div>
      </div>
    </section>;
};